var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-end w-100 container-geral-settings"},[_c('div',{staticClass:"mt-5",staticStyle:{"width":"90%"}},[_c('Company')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }